/**
  Generated File
  Do not manually modify, use `npm run build:genRulesIndex` instead.
**/

export default {
  break: {
    'add-required-object-property': require('./break/add-required-object-property.js'),
    'add-required-param': require('./break/add-required-param.js'),
    'delete-definition': require('./break/delete-definition.js'),
    'delete-method': require('./break/delete-method.js'),
    'delete-operation-id': require('./break/delete-operation-id.js'),
    'delete-path': require('./break/delete-path.js'),
    'delete-produce': require('./break/delete-produce.js'),
    'delete-response': require('./break/delete-response.js'),
    'edit-array-items-type': require('./break/edit-array-items-type.js'),
    'edit-base-path': require('./break/edit-base-path.js'),
    'edit-host': require('./break/edit-host.js'),
    'edit-object-property-required': require('./break/edit-object-property-required.js'),
    'edit-object-property-type': require('./break/edit-object-property-type.js'),
    'edit-operation-id': require('./break/edit-operation-id.js'),
    'edit-param-collection-format': require('./break/edit-param-collection-format.js'),
    'edit-param-in': require('./break/edit-param-in.js'),
    'edit-param-required': require('./break/edit-param-required.js'),
    'edit-param-type': require('./break/edit-param-type.js'),
    'edit-response': require('./break/edit-response.js'),
  },
  smooth: {
    'add-definition': require('./smooth/add-definition.js'),
    'add-description': require('./smooth/add-description.js'),
    'add-method': require('./smooth/add-method.js'),
    'add-optional-object-property': require('./smooth/add-optional-object-property.js'),
    'add-optional-param': require('./smooth/add-optional-param.js'),
    'add-path': require('./smooth/add-path.js'),
    'add-response': require('./smooth/add-response.js'),
    'delete-object-property': require('./smooth/delete-object-property.js'),
    'delete-param': require('./smooth/delete-param.js'),
    'edit-description': require('./smooth/edit-description.js'),
    'edit-summary': require('./smooth/edit-summary.js'),
  },
};



/** WEBPACK FOOTER **
 ** ./src/rules/index.js
 **/